import React from "react";
import "./LoadingCircle.css";

const LoadingCircleSingle = ({ label }) => {
  // Array of different spinner components
  const spinners = [
    <div className="loading-circle"></div>,
    <span className="double-spinner"></span>,
    <span className="double-dots-spinner"></span>,
    <span className="atom-spinner"></span>,
    <span className="third-dimension-spinner"></span>,
    <span className="double-wammer-spinner"></span>,
    <span className="double-arrow-spinner"></span>,
    <span className="the-waver-paper-spinner"></span>,
    <span className="bowl-of-soup-spinner"></span>,
    <span className="lefty-righty-spinner"></span>,
    <span className="dr-who-spinner"></span>,
  ];

  // Randomly select a spinner
  const randomSpinner = spinners[Math.floor(Math.random() * spinners.length)];

  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <span className="atom-spinner"></span>
      </div>
      {label && <div className="loading-label">{label}</div>}
    </div>
  );
};

export default LoadingCircleSingle;
